export default __webpack_public_path__ + "static/media/image.cyberlabs.6d9add56.png";